export {default as PeopleToContactSection} from './PeopleToContactSection.connect';
